// Enlaces de PDF con vencimiento (5 minutos): la app pide una clave corta al servidor y la agrega sola a los enlaces
// de PDF propios al abrirlos (window.open, enlaces <a> y descargas con fetch). Un enlace copiado vence a los 5 minutos.
import api from '../services/api';

const BACKEND = process.env.REACT_APP_BACKEND_URL || window.location.origin;
const PROTEGIDO = /^\/api\/(uploads\/pdfs\/[^/]+\.pdf|cliente-portal\/servicio\/[^/]+\/pdf)$/i;
const RENOVAR_ANTES_MS = 90 * 1000;

let clave = null;
let vence = 0;
let pidiendo = null;

export const claveArchivos = () => (clave && Date.now() < vence ? clave : null);

export const renovarClaveArchivos = () => {
  if (!localStorage.getItem('token')) {
    clave = null;
    return Promise.resolve(null);
  }
  if (!pidiendo) {
    pidiendo = api.get('/archivos/clave')
      .then((r) => { clave = r.data.k; vence = Date.now() + r.data.segundos * 1000; return clave; })
      .catch(() => null)
      .finally(() => { pidiendo = null; });
  }
  return pidiendo;
};

const propio = (u) => u.origin === window.location.origin || u.origin === new URL(BACKEND).origin;

const esProtegido = (url) => {
  try {
    const u = new URL(url, window.location.origin);
    return propio(u) && PROTEGIDO.test(u.pathname);
  } catch { return false; }
};

export const firmarUrl = (url) => {
  const k = claveArchivos();
  if (!k || typeof url !== 'string' || !esProtegido(url)) return url;
  const u = new URL(url, window.location.origin);
  u.searchParams.set('k', k);
  return u.toString();
};

// Si todavía no hay clave (recién abierta la app o al volver de suspensión) se espera a tenerla y recién se abre.
const conClave = async (url) => (claveArchivos() || !esProtegido(url) ? firmarUrl(url) : (await renovarClaveArchivos(), firmarUrl(url)));

const hayQueRenovar = () => localStorage.getItem('token') && Date.now() > vence - RENOVAR_ANTES_MS;

export const instalarEnlacesFirmados = () => {
  const abrir = window.open.bind(window);
  window.open = (url, ...resto) => {
    const texto = typeof url === 'string' ? url : url?.toString?.();
    if (!texto || claveArchivos() || !esProtegido(texto)) return abrir(firmarUrl(texto), ...resto);
    const ventana = abrir('', ...resto);
    conClave(texto).then((firmado) => { if (ventana) ventana.location.href = firmado; else abrir(firmado, ...resto); });
    return ventana;
  };
  const nativo = window.fetch.bind(window);
  window.fetch = async (entrada, opciones) => nativo(typeof entrada === 'string' ? await conClave(entrada) : entrada, opciones);
  const alTocar = (e) => {
    const a = e.target?.closest?.('a[href]');
    if (!a || !esProtegido(a.href)) return;
    if (claveArchivos()) {
      a.href = firmarUrl(a.href);
      return;
    }
    if (e.type !== 'click') return;
    e.preventDefault();
    conClave(a.href).then((firmado) => {
      a.href = firmado;
      if (a.hasAttribute('download') || !a.target || a.target === '_self') a.click();
      else window.open(firmado, a.target);
    });
  };
  document.addEventListener('click', alTocar, true);
  document.addEventListener('auxclick', alTocar, true);
  document.addEventListener('contextmenu', alTocar, true);
  renovarClaveArchivos();
  setInterval(() => { if (hayQueRenovar()) renovarClaveArchivos(); }, 5000);
  document.addEventListener('visibilitychange', () => { if (document.visibilityState === 'visible' && hayQueRenovar()) renovarClaveArchivos(); });
  window.addEventListener('online', () => { if (hayQueRenovar()) renovarClaveArchivos(); });
};
